import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';

import { Store } from '@ngrx/store';

import { AssignedJobsActions } from '@recruitee/requisitions-data';

@Injectable()
export class RequisitionJobsResolver {
  constructor(private store: Store) {}

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const requisitionId = route.parent?.params.id;
    this.store.dispatch(AssignedJobsActions.fetchOne({ payload: { id: requisitionId } }));
    return true;
  }
}
